export default {
      id: "info-transparent-usage",
      viewBox: "0 0 17 17",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#info-transparent",
      toString: function () {
        return this.url;
      }
    }